import { render } from "./About.vue?vue&type=template&id=6dcb0528"
const script = {}
script.render = render

export default script